import { KEYS, getItem, setItem } from '@/store/localStorage'
import { PERFIL_AUTENTICADO } from '@/constants/constants'
import jwtDecode from 'jwt-decode'

const getUsuario = () => {
  return !!getItem(KEYS.LOGIN.usuario) || !!getItem(KEYS.LOGIN.jwt) ? jwtDecode(getItem(KEYS.LOGIN.jwt)) : null
}

const getIsUsuarioAutenticado = () => {
  const usuario = getUsuario()
  return usuario && usuario.moduloSelecionado ? (usuario.moduloSelecionado.codigo === PERFIL_AUTENTICADO.CAGEO ||
    usuario.moduloSelecionado.codigo === PERFIL_AUTENTICADO.CAVISTORIA ||
    usuario.moduloSelecionado.codigo === PERFIL_AUTENTICADO.CREDENCIADO ||
    usuario.moduloSelecionado.codigo === PERFIL_AUTENTICADO.GESTAO_DE_CREDENCIADOS)
    : false
}

const logout = () => {
  window.location.replace(`${process.env.VUE_APP_SICARF_URL}/#/selecionarModulo`, '_self')
}

const getToken = () => getItem(KEYS.LOGIN.token);

const setToken = (token) => {
  setItem(KEYS.LOGIN.jwt, `Bearer ${token}`)
  setItem(KEYS.LOGIN.token, token)
  window.location = '/'
}

export { getUsuario, getIsUsuarioAutenticado, logout, setToken, getToken }
